import Vue from 'vue';
import VueI18n, { LocaleMessages } from 'vue-i18n';
import { KeyStringObject } from '@/types';

Vue.use(VueI18n);

function capitalizeKeys(locale: KeyStringObject) {
  Object.keys(locale).forEach((key: string) => {
    if (!key || typeof key !== 'string') {
      return;
    }
    const capitalizedKey = `${key[0].toUpperCase()}${key.slice(1)}`;
    const hasAlreadyCapitalizedKey = Object.prototype.hasOwnProperty.call(locale, capitalizedKey);
    if (hasAlreadyCapitalizedKey) return;
    locale[capitalizedKey] = `@.capitalize:${key}`;
  });
}

function loadLocaleMessages(): LocaleMessages {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages: LocaleMessages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
      capitalizeKeys(messages[locale]);
    }
  });
  return messages;
}

const numberFormats = {
  ru: {
    decimal: {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
  },
};

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages(),
  silentTranslationWarn: true,
  numberFormats,
});
